import "../../common/js/polyfills"
import Bugsnag from "@bugsnag/js"
import Alpine from "alpinejs"
import fraudNetIntegration from "./fraudNetIntegration"
import translation from "../../common/js/translation"
import { load } from "./localStorage"
import { LOCAL_STORAGE_KEY } from "./dataStore"

function getLocalStorageToken() {
  const data = load(LOCAL_STORAGE_KEY)

  if (!data || !data.values) return

  return data.values.token
}

async function fetchDataFromApi(dataStore) {
  const currentUrl = window.location.href
  const decodedUrl = decodeURIComponent(currentUrl)
  const params = {}
  const hashFragments = decodedUrl.split("#")
  for (let fragment of hashFragments) {
    if (fragment.includes("=")) {
      const [key, value] = fragment.split("=", 2)
      params[key] = value
    } else {
      params[fragment] = ""
    }
  }
  const token = params["token"] || params["stored-token"]
  
  const localStorageToken = getLocalStorageToken()

  if (token && localStorageToken !== token) {
    dataStore.values = { token }
    await dataStore.pull()
  }
}

function handleImageLoad(img) {
  if (img.complete) {
    // Image was already loaded from cache
    window.requestAnimationFrame(() => {
      img.classList.add("pipe-img-loaded")
    })
  } else {
    // Wait for image to load
    img.onload = () => img.classList.add("pipe-img-loaded")
  }
}

function watchForNewImages() {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === "IMG") {
          handleImageLoad(node)
        } else if (node.querySelectorAll) {
          // Potentially the whole chunk of HTML can be added,
          // which may contain multiple imgs inside
          node.querySelectorAll("img").forEach(handleImageLoad)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

function handleDOMContentLoaded() {
  const body = document.querySelector("body")

  // Add a CSS class to trigger animation
  window.requestAnimationFrame(() => {
    body.classList.add("pipe-dom-content-loaded")
  })

  const svgs = document.querySelectorAll("svg[data-pipe-svg-animation]")
  svgs.forEach((svg) => {
    window.requestAnimationFrame(() => {
      svg.classList.add("pipe-svg-loaded")
    })
  })

  const imgs = document.querySelectorAll("img")
  imgs.forEach(handleImageLoad)
  watchForNewImages()
}

const BUGSNAG_API_KEY = "a383d74fed09040a8180a6388ef025f7"

export default ({
  components,
  dataStore,
  bugsnagApiKey,
  DOMContentLoadedCallback,
}) => {
  // Init Bugsnag
  bugsnagApiKey = bugsnagApiKey || BUGSNAG_API_KEY
  Bugsnag.start({ apiKey: bugsnagApiKey, appVersion: appVersion })

  // DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    handleDOMContentLoaded()

    if (DOMContentLoadedCallback) DOMContentLoadedCallback()
  })

  // Init Alpine
  window.Alpine = Alpine

  components.forEach(({ name, data }) => {
    Alpine.data(name, data)
  })

  fetchDataFromApi(dataStore).then(async () => {
    Alpine.store("data", dataStore)
    Alpine.start()
    translation.onInit()
  })

  // Init FraudNet
  fraudNetIntegration()
}
